export function _random() {
  let tempArr = new Uint32Array(1);
  window.crypto.getRandomValues(tempArr);
  console.log('random : ', tempArr[0]);
  return tempArr[0];
}
